import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FLOW_TYPE, CREDIT_TYPE } from '../../../../framework/App/AppConstants';
import _ from 'lodash';
import AnnouncementPopup from '../../../../shared-components/AnnouncementPopup/AnnouncementPopup';
import Button, { BUTTON_STYLE } from '../../../../shared-components/Button/Button';
import './CreditDetailsPopup.less';
import Paragraph from '../../../../shared-components/Typography/Paragraph';
import CreditDetails from '../../../components/CreditDetails/CreditDetails';
import { RBPInstallment, RBPNoInterest, RBPCreditLimit } from '../../../components/CreditDetails/RiskBasedPricing';


const LOCALE_PREFIX = 'GB/pages/CAPage/CreditDetailsPopup';

export class CreditDetailsPopup extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)).isRequired,
        onClose: PropTypes.func.isRequired,
        creditType: PropTypes.string.isRequired,
    };

    creditDetailsTemplate = (creditType) => {
        if (creditType === CREDIT_TYPE.NO_INTEREST) {
            return <RBPNoInterest />;
        }

        if (creditType === CREDIT_TYPE.INSTALLMENTS) {
            return <RBPInstallment />;
        }

        return <RBPCreditLimit />;
    }

    render() {
        const {
            intl,
            flow,
            onClose,
            creditType,
        } = this.props;

        const footer = (
            <div id="action-buttons" className="buttons">
                <Button
                    data-automation-id="closeApprovedPopUp"
                    btnStyle={BUTTON_STYLE.PP_PRIMARY}
                    className="closeApprovedPopUp"
                    id="closeApprovedPopUp"
                    name="closeApprovedPopUp"
                    tabIndex="0"
                    onClick={onClose}
                >{intl.formatMessage({ id: `${LOCALE_PREFIX}.continue` })}</Button>
            </div>
        );

        return (
            <div className="ApprovalPopup CreditDetailsPopup gb-wrapper">
                <AnnouncementPopup
                    footer={footer}
                    id="ApprovalPopup"
                    onClose={onClose}
                    showXButton={true}
                    stickyFooter={false}
                >
                    <div className="vx_text-3 AgreementPage-preForm-title">
                        <FormattedMessage id={`${LOCALE_PREFIX}.approvedHeader`} />
                    </div>
                    <Paragraph>
                        <FormattedMessage id={`${LOCALE_PREFIX}.reviewCreditDetails`} />
                    </Paragraph>
                    <CreditDetails.Container>
                        {this.creditDetailsTemplate(creditType)}
                       
                    </CreditDetails.Container>
                </AnnouncementPopup>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
});

export default connect(mapStateToProps)(injectIntl(CreditDetailsPopup));
